import React from "react";
import { ArrowRight } from "lucide-react";
import { useApp } from "@/store/AppContext";

export default function FooterCTA() {
  const { openContact, theme } = useApp();

  return (
    <>
      <section
        data-testid="footer-cta"
        className="relative overflow-hidden py-28 bg-app-alt"
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            opacity: theme === "dark" ? 0.35 : 0.12,
            background:
              "radial-gradient(circle at 50% 50%, rgba(201,169,97,0.25) 0%, transparent 60%), url('/generated/footer-globe.png') center/cover no-repeat",
          }}
        />
        <div className="relative max-w-4xl mx-auto text-center px-6">
          <span className="text-xs uppercase tracking-[0.3em] text-[#C9A961] font-semibold">Your next shore</span>
          <h2 className="font-serif text-4xl sm:text-5xl mt-4 leading-tight text-app">
            Start your journey <em className="text-[#C9A961]">today.</em>
          </h2>
          <p className="mt-5 text-app-muted max-w-xl mx-auto">
            One short form is all it takes. Answer a few questions and our
            senior advisors will follow up within 24 hours.
          </p>
          <button
            data-testid="footer-cta-btn"
            onClick={() => openContact()}
            className="mt-8 rounded-full px-8 py-4 font-semibold inline-flex items-center gap-2 bg-[#C9A961] text-[#0B1E3F] hover:bg-[#D8BA72] transition"
          >
            Start your journey <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </section>

      <footer className="bg-app border-t border-[var(--card-border)] py-8">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-app-muted">
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="NS-I" className="h-12 w-auto logo-blend" />
            <span className="font-serif text-xl text-app font-bold">NS-I</span>
          </div>
          <div>© 2026 NextShore Immigration. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="/crm/login" data-testid="footer-staff-link" className="hover:text-[#C9A961]">Staff Portal</a>
            <button onClick={() => openContact()} className="hover:text-[#C9A961]">Contact</button>
            <a href="#" className="hover:text-[#C9A961]">Privacy</a>
          </div>
        </div>
      </footer>
    </>
  );
}
